import { environment } from "src/environments/environment";

export const GlobalComponent = {
    API_URL: environment.API_URL
}

export const Roles = {
    admin: "Administrador"
};
  